const setDarkMode = (state = false, action) => {
    switch (action.type) {
        case 'SET_DARK_MODE':
            return action.active
        default:
            return state
    }
}

export default setDarkMode;